import './App.css';
import { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";
import SoftBox from "components/SoftBox";
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";
import theme from "assets/theme";
import routes from "routes";
import { useSoftUIController, setMiniSidenav, setOpenConfigurator } from "context";
import brand from "assets/images/logo-ct.png";

export default function App() {
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, layout, openConfigurator, sidenavColor } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const { pathname } = useLocation();

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  useEffect(() => {
    const loginData = JSON.parse(localStorage.getItem("loginData") || sessionStorage.getItem("loginData"));

    if (loginData?.isLoggedIn) {
      if (loginData.timestamp === null) {
        setIsAuthenticated(true);
      } else {
        const sessionDuration = 24 * 60 * 60 * 1000;
        const currentTime = Date.now();
        const isSessionValid = currentTime - loginData.timestamp < sessionDuration;

        setIsAuthenticated(isSessionValid);

        if (!isSessionValid) {
          localStorage.removeItem("loginData");
          sessionStorage.removeItem("loginData");
        }
      }
    } else {
      setIsAuthenticated(false);
    }
  }, []);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        if (route.children) {
          return (
            <Route key={route.key} path={route.route} element={route.component}>
              {route.children.map((child) => (
                <Route 
                  key={`${route.key}-${child.path}`}
                  path={child.path}
                  element={child.component}
                />
              ))}
            </Route>
          );
        }
        
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });
  // const getRoutes = (allRoutes) =>
  //   allRoutes.map((route) => {
  //     if (route.collapse) {
  //       return getRoutes(route.collapse);
  //     }

  //     if (route.route) {
  //       return (
  //         <Route 
  //           exact 
  //           path={route.route} 
  //           element={
  //             route.route === "/authentication/sign-in" 
  //               ? isAuthenticated 
  //                 ? <Navigate to="/dashboard" />
  //                 : route.component 
  //               : isAuthenticated 
  //                 ? route.component
  //                 : <Navigate to="/authentication/sign-in" />
  //           } 
  //           key={route.key} 
  //         />
  //       );
  //     }

  //     return null;
  //   });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {isAuthenticated ? (
        <>
          {layout === "dashboard" && (
            <>
              <Sidenav
                color={sidenavColor}
                brand={brand}
                brandName="Dreamer Admin Panel"
                routes={routes}
                onMouseEnter={handleOnMouseEnter}
                onMouseLeave={handleOnMouseLeave}
              />
              <Configurator />
              {/* {configsButton} */}
            </>
          )}
          {layout === "vr" && <Configurator />}
          <Routes>
            {getRoutes(routes)}
            <Route path="*" element={<Navigate to="/dashboard" />} />
          </Routes>
        </>
      ) : (
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/authentication/sign-in" />} />
        </Routes>
      )}
    </ThemeProvider>
  );
}
